import React from 'react';
import { useQuery } from 'react-query';
import { Table } from 'antd';
import { ApiClient } from '../../api';
import { DrawerLayout } from '../../Layout';
import moment from 'moment';

const Columns = [
    {
        title: 'ID',
        dataIndex: 'id',
    },
    {
        title: 'User Id',
        dataIndex: 'userId',
    },
    {
        title: 'Permanent',
        dataIndex: 'isPermanent',
        render: (value) => (value ? 'Yes' : 'No'),
    },
    {
        title: 'Reason',
        dataIndex: 'reason',
        render: (value) => value || 'No Reason Provided',
    },
    {
        title: 'Created At',
        dataIndex: 'createdAt',
        render: (value) => moment(value).format('DD/MM/YYYY'),
    },
    {
        title: 'Blocked Till',
        dataIndex: 'blockedTill',
        render: (value) => (value ? moment(value).format('DD/MM/YYYY') : 'No Date Provided'),
    },
];

const BlockedUserContainer = () => {
    const { data: blockedUsers, isFetching } = useQuery<any[]>('blockedUsers', ApiClient.fetchBlockedUsers, {
        refetchOnWindowFocus: false,
        initialData: [],
    });

    const reversedBlockedUsers = React.useMemo(() => {
        return blockedUsers?.slice().reverse();
    }, [blockedUsers]);

    return (
        <DrawerLayout>
            <h1>Blocked Users</h1>
            <Table
                loading={isFetching}
                rowKey={'id'}
                columns={Columns}
                dataSource={reversedBlockedUsers}
                locale={{ emptyText: 'No Users' }}
                pagination={false}
            />
        </DrawerLayout>
    );
};

export default BlockedUserContainer;
